import { Link } from "react-router-dom";
import SectionTitle from "@/components/feature/SectionTitle";
import { articles } from "@/mocks/articles";

export default function FeaturedSection() {
  const sorted = [...articles].sort((a, b) => b.hot - a.hot);
  const main = sorted[0];
  const side = sorted.slice(1, 4);

  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <SectionTitle
          eyebrow="今日必看"
          title="今天最值得花 5 分钟的三件事"
          desc="按热度与阅读完成率挑选，结论前置，不为凑长度注水。"
        />
        <Link
          to="/hot"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          查看完整热榜
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.35fr_1fr]">
        <article className="group flex flex-col overflow-hidden rounded-card border border-background-200 bg-background-50">
          <div className="relative w-full overflow-hidden" style={{ aspectRatio: "16 / 9" }}>
            <img
              src={main.cover}
              alt={`${main.title} - 今日最热话题封面`}
              title={`${main.title} · 黑料在线`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/15 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="rounded-full bg-accent-500 px-2.5 py-1 text-xs font-label text-accent-950">
                {main.categoryName}
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                <Link to={`/article/${main.id}`} className="cursor-pointer hover:underline">
                  {main.title}
                </Link>
              </h3>
              <p className="mt-2 hidden max-w-2xl text-sm leading-relaxed text-background-200 sm:block">
                {main.excerpt}
              </p>
            </div>
          </div>
          <div className="flex items-center justify-between gap-3 px-5 py-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-user-3-line" />
              {main.author}
            </span>
            <span className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <i className="ri-time-line" />
                {main.readTime}
              </span>
              <span className="flex items-center gap-1 text-primary-600">
                <i className="ri-fire-line" />
                {main.hot}
              </span>
            </span>
          </div>
        </article>

        <div className="flex flex-col gap-4">
          {side.map((item) => (
            <article
              key={item.id}
              className="group flex gap-4 rounded-card border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
            >
              <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md sm:w-28">
                <img
                  src={item.cover}
                  alt={`${item.title} - 话题封面`}
                  title={`${item.title} · 黑料在线`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <span className="text-xs font-label text-secondary-700">{item.categoryName}</span>
                <h3 className="mt-1 font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                  <Link
                    to={`/article/${item.id}`}
                    className="cursor-pointer transition-colors group-hover:text-primary-700"
                  >
                    {item.title}
                  </Link>
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500">
                  {item.date} · {item.readTime}
                </p>
              </div>
            </article>
          ))}
          <Link
            to="/topics"
            className="flex items-center justify-between rounded-card border border-dashed border-background-300 px-5 py-4 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
          >
            <span>按专题浏览全部内容</span>
            <i className="ri-arrow-right-up-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}